import { render } from "./AdminOrderCancelList.vue?vue&type=template&id=5c544530&scoped=true&ts=true&lang=true"
import script from "./AdminOrderCancelList.vue?vue&type=script&lang=ts"
export * from "./AdminOrderCancelList.vue?vue&type=script&lang=ts"

import "./AdminOrderCancelList.vue?vue&type=style&index=0&id=5c544530&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c544530"]])

export default __exports__